import * as React from "react";
import {PaymentInfoType} from "../../../../cart/CartContextProvider/CartContextProvider";
import {useCheckoutContext} from "../../../CheckoutContextProvider/CheckoutContextProvider";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {purchase} from "../../../../lib/payments/purchase";
import {Button, ButtonStyles, ButtonType} from "../../../../lib/form/Button/Button";
import Spinner from "../../../../utils/loader/Spinner";
import {PurchaseButtonProps} from "./PurchaseButtonProps";

type DefaultPurchaseButtonProps = Omit<PurchaseButtonProps, "paymentModule"> & {
  paymentInfos: PaymentInfoType | undefined;
  occurrence: string;
};

/* PAYPAL EXPRESS AND APPLE PAY */
const DefaultPurchaseButton: React.FC<DefaultPurchaseButtonProps> = ({
  purchaseButtonErrors,
  occurrence,
  paymentInfos,
}) => {
  const {checkout} = useCheckoutContext();
  const {t} = useTranslation(["errorcodes", "translations"]);
  const [submitted, setSubmitted] = useState(false);

  const onPurchase = async () => {
    if (!paymentInfos) {
      purchaseButtonErrors(new Error("No nonce and funding source given"), occurrence);

      return;
    }

    setSubmitted(true);

    const {nonce, paymentSource} = paymentInfos;
    try {
      await purchase({checkout, nonce, paymentSource});
    } catch (err) {
      setSubmitted(false);
      purchaseButtonErrors(err as Error, occurrence);
    }
  };

  return (
    <Button
      action={onPurchase}
      styles={[ButtonStyles.wide]}
      type={submitted ? ButtonType.disabled : ButtonType.default}
    >
      {submitted ? <Spinner /> : t("checkout.purchaseNow")}
    </Button>
  );
};

export default DefaultPurchaseButton;
